import React from 'react'
import { HostingProps2, HostingProps3, } from '../Reusable/props/HostingProps'

const Best = () => {
    return (
        <div className='lg:pt-[12%] bg-[#161616] lg:pb-[8%] flex flex-col lg:px-[8%] px-[4%] gap-8'>
            <div data-aos="zoom-out" className='flex w-full items-center justify-center'>
                <div className='flex w-full items-center justify-center'>
                    <div className='lg:w-[50%] gap-4 w-full flex flex-col items-center justify-center'>
                        <p className='lg:text-[50px] text-[30px] text-white font-semibold '>Why We are <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                            Best
                        </span></p>
                        <p className='text-[15px] text-[#ffffff] text-center'>Join the agricultural revolution with Blockfarms — leveraging blockchain to enhance farm-to-table traceability, ensure fair pricing, and promote sustainable farming practices globally.</p>
                    </div>
                </div>
            </div>
            <div className='flex flex-col gap-6'>
                <HostingProps3
                    img={"/Blockfarm/hosting/hostinground.svg"}
                    heading={"Round-the-Clock Technical Support"}
                    paragraph={"Ensure uninterrupted operations with our 24/7 dedicated onsite technicians. Our expert engineers are always ready to provide immediate assistance, ensuring your equipment runs at peak efficiency without downtime."}
                />

                <HostingProps2
                    // img={"/Blockfarm/hosting/hosting expert.svg"}
                    img={"/Blockfarm/hosting/technician.jpg"}
                    heading={"Expert Maintenance & Rapid Repair Services"}
                    paragraph={"We have an onsite repair center within all our facilities, in which our team of engineers are available 24/7 to tend to all repairs and maintenance in a swift manner to efficiently minimize downtime."}
                />
                {/* <HostingPropsnew
                    img={"/Blockfarm/hosting/technician.jpg"}
                    heading={"24/7 Dedicated Onsite Technicians"}
                    paragraph={"Our onsite engineers are available round-the-clock to offer remote hands assistance, guaranteeing the smooth operation of your equipment. ."}
                /> */}
                {/* <HostingProps2
                    img={"/Blockfarm/hosting/hosting expert.svg"}
                    heading={"Expert Maintenance & Rapid Repair Services"}
                    paragraph={"Experience minimal downtime with our 24/7 Maintenance and Repair Center. Our skilled engineers are equipped to handle all repairs and maintenance swiftly, ensuring your mining equipment operates at optimal performance at all times."}
                /> */}
                
            </div>
        </div>
    )
}

export default Best